/**
 * Pure formatters for the InvoiceDetailModal. Kept in a sibling .ts
 * file so the .tsx side stays component-only (react-refresh rule).
 */

export function formatInvoiceDate(iso: string | null): string {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return iso;
  }
}

export function formatInvoiceCurrency(val: string | number | null): string {
  if (val == null) return '—';
  const num = typeof val === 'string' ? Number(val) : val;
  if (Number.isNaN(num)) return '—';
  return num.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
  });
}

export function formatInvoiceQty(val: string | number | null): string {
  if (val == null) return '—';
  const num = typeof val === 'string' ? Number(val) : val;
  if (Number.isNaN(num)) return '—';
  // Drop trailing zeros for tidy display but keep up to 4 decimals.
  return num.toLocaleString(undefined, {
    maximumFractionDigits: 4,
  });
}
